import { useState } from 'react'
import type { StepTask } from '../../types'
import { Field, ReadonlyValue, SectionHeader, TextInput } from './fields'
import { ConnectorConfig } from './ConnectorConfig'

export interface MatchlistDrawerProps {
  task: StepTask
  onChange: (updater: (t: StepTask) => StepTask) => void
}

export function MatchlistDrawer(_props: MatchlistDrawerProps) {
  // MATCHLIST steps carry no parameters in the workflow JSON.
  // ── Additional config (mockup, not persisted to the workflow JSON) ──
  const [source, setSource] = useState('')
  const [matchThreshold, setMatchThreshold] = useState(85)

  return (
    <div className="flex flex-col gap-4">
      <SectionHeader title="Existing ops center workflow config" />
      <Field label="Parameters">
        <ReadonlyValue>
          <span className="text-[#8fa0bd]">No parameters — a blocklist/matchlist check step.</span>
        </ReadonlyValue>
      </Field>

      <SectionHeader title="Proposed additional config" hint="Mockup · not saved" />

      <Field label="List / source">
        <TextInput value={source} onChange={(e) => setSource(e.target.value)} placeholder="e.g. internal_blocklist" />
      </Field>

      <Field label="Match threshold (%)">
        <TextInput
          type="number"
          min={0}
          max={100}
          value={matchThreshold}
          onChange={(e) => setMatchThreshold(Number(e.target.value))}
        />
      </Field>

      <ConnectorConfig secretPathPlaceholder="/frankieone/{customer}/con_matchlist" />
    </div>
  )
}
